import React, { useMemo } from 'react'
import { Loading } from 'components/loading'
import { AvailabilityCalendar } from 'domain/feature/public/meeting-room-reservation/AvailabilityCalendarModal'
import { AvailabilityScheduleInput } from 'domain/feature/public/meeting-room-reservation/AvailabilityCalendarModal/types'
import {
  MEETING_ROOM_SETTINGS_API,
} from 'domain/feature/hub/company/meeting-room/settings/api/constants'
import {
  mapGetResponseToFormState,
  MeetingRoomSettingsGetResponse,
} from 'domain/feature/hub/company/meeting-room/settings/api/mappers'
import { useMeetingRoomSpaceOptions } from 'domain/feature/hub/company/meeting-room/meeting-room-solicitation/hooks/useMeetingRoomSpaceOptions'
import { GetFormat, useGet } from 'sharedKernel/api'
import { trans } from 'sharedKernel/i18n'
import { PageHeader, PageTitle } from '../pageLayoutStyles'

export const HubCompanyMeetingRoomReservedPage = (): JSX.Element => {
  const { spaceOptions, isLoading: isRoomsLoading } = useMeetingRoomSpaceOptions()

  const settingsRequest: GetFormat = useMemo(
    () => ({
      url: MEETING_ROOM_SETTINGS_API.BASE,
    }),
    []
  )

  const { data: settingsData, isLoading: isSettingsLoading } =
    useGet<MeetingRoomSettingsGetResponse>(
      settingsRequest,
      'meeting-room-reserved-settings'
    )

  const rooms = useMemo(
    () => spaceOptions.map(option => ({ id: option.id, name: option.name })),
    [spaceOptions]
  )

  const scheduleSettings = useMemo((): AvailabilityScheduleInput | null => {
    if (settingsData?.data == null) return null
    const { rulesData } = mapGetResponseToFormState(settingsData)
    return {
      openTime: rulesData.openTime,
      closeTime: rulesData.closeTime,
      workingDays: rulesData.days,
    }
  }, [settingsData])

  const isLoading = isRoomsLoading || isSettingsLoading

  return (
    <>
      <PageHeader>
        <PageTitle>{trans('Espaços reservados')}</PageTitle>
      </PageHeader>

      {isLoading ? (
        <Loading />
      ) : (
        <AvailabilityCalendar
          rooms={rooms}
          settings={scheduleSettings}
          isActive={rooms.length > 0}
          variant="page"
        />
      )}
    </>
  )
}
